module.exports = __webpack_public_path__ + "img/invite.403faaca.png";